import { z } from "zod";
// Schema for module translations (embedded in DynamoDB item)
export const ModuleTranslationSchema = z.object({
    name: z.string().min(1),
    description: z.string().nullable().optional(),
    summary: z.string().nullable().optional(),
});
// Pre-computed stats for DynamoDB denormalization
export const ModuleStatsSchema = z.object({
    exercise_count: z.number().min(0).default(0),
    published_exercise_count: z.number().min(0).default(0),
});
// Main Module schema for DynamoDB
export const ModuleSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1),
    course_id: z.number(),
    description: z.string().nullable(),
    video_link: z.string().nullable().optional(),
    thumbnail_url: z.string().nullable().optional(),
    order_index: z.number().optional(),
    estimated_duration_minutes: z.number().optional(),
    is_published: z.boolean().default(false),
    slug: z.string().nullable().optional(),
    summary: z.string().nullable().optional(),
    pdf_key: z.string().nullable().optional(),
    hide_video: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    // Denormalized course info (DynamoDB - avoid joins)
    course_name: z.string().optional(),
    course_slug: z.string().optional(),
    // Embedded translations (DynamoDB denormalization)
    translations: z.record(z.string(), ModuleTranslationSchema).optional(),
    // Pre-computed stats (DynamoDB denormalization)
    stats: ModuleStatsSchema.optional(),
});
// Schema with exercise count (for backward compatibility)
export const ModuleWithExerciseCountSchema = ModuleSchema.extend({
    exercises_count: z.number(),
});
// Schema for creating/updating modules
export const ModulePayloadSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1),
    course_id: z.number(),
    description: z.string().nullable().optional(),
    video_link: z.string().nullable().optional(),
    thumbnail_url: z.string().nullable().optional(),
    order_index: z.number().optional(),
    estimated_duration_minutes: z.number().optional(),
    is_published: z.boolean().optional(),
    slug: z.string().nullable().optional(),
    summary: z.string().nullable().optional(),
    pdf_key: z.string().nullable().optional(),
    hide_video: z.boolean().optional(),
    // Denormalized course info for create operations
    course_name: z.string().optional(),
    course_slug: z.string().optional(),
    translations: z.record(z.string(), ModuleTranslationSchema).optional(),
});
// Schema for module with exercises (used in queries that need related data)
export const ModuleWithExercisesSchema = ModuleSchema.extend({
    exercises: z.array(z.unknown()).optional(), // Exercise[] - uses z.unknown() to avoid circular deps with exercise.ts
});
